import { SAGA_ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces'
import { Dialog } from '../../_config/types'

export interface DeepDiveReducer {
    insightOverViewData: Dialog
}

const initialState: DeepDiveReducer = { insightOverViewData: null }

const DeepDiveReducer = (state = initialState, action: ActionExtended) => {
    if (action.type === SAGA_ACTIONS.DEEP_DIVE.INSIGHT_OVERVIEW) {
        return {
            ...state,
            insightOverViewData: action.payload,
        }
    }

    return state
}

export default DeepDiveReducer
